<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-secondary)]">
    <template #left>
      <RouterLink
        class="bg-primary bg-[url(/bg.jpg)] bg-cover h-full flex items-top justify-left p-8 relative"
        style="width: 35vw"
        to="/"
        aria-label="Visit homepage"
      >
        <div class="absolute inset-0 bg-primary opacity-65"></div>
        <Logo :height="28" start="#FFF" class="relative z-10" />
      </RouterLink>
    </template>
    <template #content>
      <main
        class="h-full overflow-y-scroll flex mx-auto p-8"
        :class="isSignupPage ? 'items-start justify-center' : 'items-center justify-center'"
      >
        <div :class="isSignupPage ? 'w-[80%]' : 'w-[65%]'">
          <RouterView />
        </div>
      </main>
    </template>
  </VaLayout>

  <VaLayout v-else class="bg-[var(--va-background-secondary)]">
    <template #content>
      <div class="p-4">
        <main class="h-full flex flex-row justify-center items-center">
          <div class="w-[80%] flex flex-col items-start">
            <RouterLink class="py-4" to="/" aria-label="Visit homepage">
              <Logo class="mb-2" style="max-width: 132px" start="#43281C" />
            </RouterLink>
            <RouterView />
          </div>
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import Logo from '../components/Logo.vue'

const breakpoint = useBreakpoint()
const route = useRoute()

// Check if current route is login page
const isSignupPage = computed(() => route.name === 'signup')
</script>
